module.exports = {
    "entityName": "reference",
    "pagination": {
        "rowsPerPage": 10,
        "page": 1,
        "sortBy": "id",
        "descending": true
    },
    "fields": [
        {
            "value": "name",
            "text": "Name",
            render: item => `${item.name} ${item.surname}`,
            "type": "text",
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required"
            ]
        },
        {
            "value": "surname",
            "text": "Surname",
            "type": "text",
            "validators": [
                "required"
            ]
        },
        {
            "value": "email",
            "text": "Email",
            "type": "text",
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required",
                "email"
                //issue email 200 caratteri
                ,
                "emaillen"
                //issue email 200 caratteri
            ]
        },
        {
            "value": "phone",
            "text": "Phone",
            "type": "text",
            "table": {
                "sortable": true,
                "filter": true
            },
            "validators": [
                "required"
            ]
        }
    ],
    "actions": ["remove"]
}